import React, { use, useEffect } from "react";
import { BankForm } from "./Forms/BankForm";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { Container, Form, Spinner } from "reactstrap";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  useGetOneBankQuery,
  useUpdateBankMutation,
} from "../../services/basicData/basicData";
import { useParams } from "react-router";
import { FormSkeleton } from "./FormFieldSkeletons";

export const EditBank = () => {
  const { t } = useTranslation();

  const { id } = useParams();
  const {
    data: bankResponse,
    isLoading,
    isFetching,
  } = useGetOneBankQuery({ id });
  const bank = bankResponse?.data?.data;
  const loading = isLoading || isFetching;
  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm();
  const { mutate: updateBank, isPending } = useUpdateBankMutation(setError);

  const onSubmit = (data) => {
    updateBank(data);
  };

  useEffect(() => {
    if (bank) {
      reset(bank);
    }
  }, [bank]);

  return (
    <Stack gap={2}>
      <PageHeader
        title={t("EDIT_BANK")}

      />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {loading ? (
            <FormSkeleton />
          ) : (
            <>
              <BankForm control={control} errors={errors} />
              <Button variant="primary" type="submit" disabled={isPending}>
                {isPending ? (
                  <>
                    <Spinner size="sm" />
                    {t("UPDATING_BANK")}
                  </>
                ) : (
                  t("UPDATE_BANK")
                )}
              </Button>
            </>
          )}
        </Form>
      </Container>
    </Stack>
  );
};
